import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "gr53VQ",
    defaultMessage: "Create Page",
    description: "page header",
  },
  seoOptionsDescription: {
    id: "Id9vlh",
    defaultMessage:
      "Add search engine title and description to make this page easier to find",
    description: "page seo options description",
  },
  hiddenLabel: {
    id: "/TK7QD",
    defaultMessage: "Hidden",
    description: "page label",
  },
  hiddenSecondLabel: {
    id: "GZgjK7",
    defaultMessage: "will be visible from {date}",
    description: "page",
  },
  visibleLabel: {
    id: "X26jCC",
    defaultMessage: "Visible",
    description: "page label",
  },
});
